module.exports = __webpack_public_path__ + "img/h9.8d661491.jpg";